/**
 * @file Computes an identity avatar's text and background colors.
 */
import { blue, gray } from "@ant-design/colors";

import { ROLES, INVESTOR_STATUSES } from "@components/Domain";

type Role = {
  color: string[];
};

/**
 * Returns the avatar's text and background colors for the role, falling
 * back to a gray or blue pair for a prospect or a not-yet-active investor.
 */
const getColors = (
  roleId: string,
  role: Role,
  status: string | undefined,
  colorBgLayout: string,
): { color: string; backgroundColor: string } => {
  const { color: colorOptions } = role;

  let color = colorOptions[5];
  let backgroundColor = colorOptions[0];

  const isInvestor = roleId === ROLES.INVESTOR;

  if (!isInvestor) {
    return { color, backgroundColor };
  }

  const isActive = status === INVESTOR_STATUSES.ACTIVE;

  if (isActive) {
    return { color, backgroundColor };
  }

  const isProspect = status === INVESTOR_STATUSES.PROSPECT;

  if (isProspect) {
    // eslint-disable-next-line prefer-destructuring
    color = gray[5];
    backgroundColor = colorBgLayout;

    return { color, backgroundColor };
  }

  // eslint-disable-next-line prefer-destructuring
  color = blue[5];
  // eslint-disable-next-line prefer-destructuring
  backgroundColor = blue[0];

  return { color, backgroundColor };
};

export default getColors;
